import React from "react";
import { toast } from "react-toastify";
import { Modal } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import _ from "lodash";
import LockIcon from "assets/svgIcons/LockIcon";
import GlobeIcon from "assets/svgIcons/GlobeIcon";
import { SiteBoxInput } from "./SiteBoxInput";
import {
  FaSortNumericDownAlt,
  FaSortNumericUp,
  FaSortAlphaDown,
  FaSortAlphaDownAlt,
} from "react-icons/fa";
import { FaClockRotateLeft } from "react-icons/fa6";
import {
  Container,
  SiteBoxContainer,
  SearchWrapper,
  SearchSection,
  ResentSite,
  AllSite,
  AllSiteBtn
} from "commonComponents/Navbar/NavbarStyled";
import { useTranslation } from "react-i18next";

export const SiteSelectionModal = ({
  open,
  onClose,
  siteId,
  siteSelectionHistory,
  setSiteSelectionHistory,
  recentThreeSiteState,
  sortedSites,
  sortConfig,
  showInternal,
  setShowInternal,
  nameSortActive,
  idSortActive,
  setIdSortActive,
  setNameSortActive,
  setSortConfig,
  siteLocation,
  allSiteFunction,
  setSearchText
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <SiteBoxContainer>
        <SearchSection>
          <SearchWrapper>
            <SiteBoxInput
              setSearchText={setSearchText}
              isShown={open}
            />
          </SearchWrapper>
        </SearchSection>

        <Container>
          <>
            {siteId !== null && siteSelectionHistory ? (
              <ResentSite>
                {recentThreeSiteState
                  ?.slice(0, 3)
                  .map((item, index) => (
                    <li
                      id={item?.Id}
                      key={index}
                      className="sitelink"
                      onClick={(e) => {
                        siteLocation(e);
                        toast.dismiss();
                      }}
                    >
                      {sortConfig.field === "Id"
                        ? `[${item?.Id}] - ${item?.Name}`
                        : `${item?.Name} - ${item?.Id}`}
                    </li>
                  ))}
              </ResentSite>
            ) : null}

            <AllSite id="myUL">
              {sortedSites?.map(
                (item, index) =>
                  ((!showInternal && !item.IsInternal) ||
                    showInternal) && (
                    <li
                      key={index}
                      className="sitelink"
                      onClick={(e) => {
                        siteLocation(e);
                        toast.dismiss();
                      }}
                    >
                      <span id={item.Id}>
                        {sortConfig.field === "Id"
                          ? `[${item?.Id}] - ${item?.Name}`
                          : `${item?.Name} - ${item?.Id}`}
                      </span>

                      {item.IsInternal && showInternal ? (
                        <LockIcon width={18} />
                      ) : null}
                    </li>
                  )
              )}
            </AllSite>
          </>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "5px 20px",
              justifyContent: "space-around",
            }}
          >
            <Tooltip title={t("Sort_alphabetically")}>
              <AllSiteBtn
                className={nameSortActive ? "active" : "disabled"}
                onClick={() => {
                  setIdSortActive(false);
                  setNameSortActive(true);

                  setSortConfig({
                    field: "Name",
                    isAscending: !sortConfig.isAscending,
                  });
                }}
              >
                {sortConfig.field === "Name" &&
                sortConfig.isAscending ? (
                  <FaSortAlphaDown
                    color={nameSortActive ? "white" : "black"}
                  />
                ) : (
                  <FaSortAlphaDownAlt
                    color={nameSortActive ? "white" : "black"}
                  />
                )}
              </AllSiteBtn>
            </Tooltip>

            <Tooltip title={t("Sort_numerically")}>
              <AllSiteBtn
                className={idSortActive ? "active" : "disabled"}
                onClick={() => {
                  setNameSortActive(false);
                  setIdSortActive(true);

                  setSortConfig({
                    field: "Id",
                    isAscending: !sortConfig.isAscending,
                  });
                }}
              >
                {sortConfig.field === "Id" &&
                sortConfig.isAscending ? (
                  <FaSortNumericUp
                    color={idSortActive ? "white" : "black"}
                  />
                ) : (
                  <FaSortNumericDownAlt
                    color={idSortActive ? "white" : "black"}
                  />
                )}
              </AllSiteBtn>
            </Tooltip>

            <Tooltip
              title={t("Show_internal_sites")}
              placement="bottom"
            >
              <AllSiteBtn
                className={showInternal ? "active" : "disabled"}
                onClick={() => setShowInternal(!showInternal)}
              >
                <LockIcon
                  color={showInternal ? "white" : "black"}
                  width={18}
                />
              </AllSiteBtn>
            </Tooltip>

            <AllSiteBtn
              className={
                siteSelectionHistory ? "active" : "disabled"
              }
              onClick={() => {
                setSiteSelectionHistory(!siteSelectionHistory);
              }}
            >
              <FaClockRotateLeft />
            </AllSiteBtn>

            <Tooltip title={t("Show_all_sites")} placement="bottom">
              <AllSiteBtn onClick={allSiteFunction}>
                <GlobeIcon width={14} height={14} />
              </AllSiteBtn>
            </Tooltip>

            <Tooltip title={t("Cancel")} placement="bottom">
              <AllSiteBtn onClick={onClose}>
                {t("Cancel")}
              </AllSiteBtn>
            </Tooltip>
          </div>
        </Container>
      </SiteBoxContainer>
    </Modal>
  );
};